jQuery(function ($) {
  let videoAnime = false;
  initAnimation();
  letsAnimate();

  function initAnimation() {
    $(".animation-group").each(function (index) {
      index = 0;
      $(this)
        .children('.animation')
        .each(function () {
          $(this).css({
            "transition-delay": 0.1 * (1 + index) + "s",
          });
          index++;
        });
    });
  }

  function letsAnimate() {
    $(".animation-group").each(function (index) {
      if (isOnView($(this))) {
        $(this).find(".animation").addClass("action");
      }
    });
    $(".animation").each(function (index) {
      if (isOnView($(this))) {
        $(this).addClass("action");
      }
      if ($(this).hasClass('add-action')) {
        $(this).delay(1000).addClass("action");
      }
    });
    if (isOnView($("#footer-video")) && videoAnime == false) {
      $("#footer-video").get(0).play();
      videoAnime = true
    }
  }
  $(window).scroll(function () {
    letsAnimate();
  });

  function isOnView(element) {
    var topOfElement = $(element).offset().top;
    var bottomOfElement = $(element).offset().top + $(element).outerHeight();
    var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
    var topOfScreen = $(window).scrollTop();

    if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement) {
      return true;
    }
  }
});
